import MyCollapse from "../../components/MyCollapse";

const AboutUs05 = () => {
  const content = [
    {
      value: 1,
      title: "우리 아이가 잘 크는지 어떻게 알 수 있나요?",
      content: () => (
        <div className="collapse-content">
          <div className="ac_text ac1-2" style={{ marginBottom: 15 }}>
            <div className="top">
              <span>
                <img
                  src="/assets/img/icon/05-01.png"
                  style={{ width: 100, minWidth: 100 }}
                  alt=""
                />
              </span>
              <p style={{ color: "#000" }}>
                CDH 환아들은 다양한 건강 문제로 인해 성장 및 발달 지연이 발생할
                수 있습니다. CDH 환아의 약 20-30%에서 성장 및 발달 지연이
                발생하는 것으로 보고되고 있습니다. 이는 유전적 소인, 수술 전후의
                전반적인 건강 상태, 수술 후 회복 속도, 폐 발달 정도, 영양상태
                등에 영향을 받습니다. 성장과 발달을 지원하기 위해 몇 가지 중요한
                요소를 지속적으로 관리해야 합니다.
              </p>
            </div>
          </div>
          <div className="ac_text ac3-3">
            <dl>
              <dt>01</dt>
              <dd>
                <h2>성장 평가</h2>
                <p>
                  정기적으로 신생아과 진료를 통해 아기의 체중과 신장 그리고
                  머리둘레가 정상 범위 내에서 성장하는지 확인해야 합니다. 성장
                  곡선을 기준으로 적절한 성장 패턴을 유지하는지 모니터링합니다.
                </p>
              </dd>
            </dl>
            <dl>
              <dt>02</dt>
              <dd>
                <h2>발달 평가</h2>
                <p>
                  CDH는 인공호흡기 치료, 저산소증 등 발달 고위험군의 위험 요인을
                  대부분 가지고 있으므로 프로토콜에 따라 베일리 발달검사, 자폐
                  위험군 검사 등 정기적인 평가를 시행하는 것이 바람직합니다.
                  발달 상태는 신생아기부터 아기를 보던 소아청소년과 선생님에게
                  정기적으로 방문할 수 있으면 좋겠지만 병원이 너무 멀리 떨어져
                  있는 등 부득이한 경우는 발달을 잘 확인해 주는 인근의
                  소아청소년과 병원이라도 정기적으로 방문하실 것을 권장합니다.
                  발달 지연이 확인될 경우 물리치료, 작업치료, 언어치료 등 적절한
                  재활 치료를 시작하는 것이 필요하며 이를 통해 아기의 운동 발달,
                  언어 발달, 인지 발달을 촉진할 수 있습니다.
                </p>
              </dd>
            </dl>
            <dl>
              <dt>03</dt>
              <dd>
                <h2>영양 관리</h2>
                <p>
                  CDH 아기들은 수유 곤란을 겪을 가능성이 높습니다. 약 30-50%의
                  CDH 아기들이 먹는 데 어려움을 겪으며, 이는 적절한 영양 섭취에
                  장애를 줄 수 있습니다. 아기의 개별적 필요를 충족하는 영양
                  계획을 세우는 것이 필수적이며, 필요할 경우 경관영양을 고려할
                  수 있습니다. 성장을 위한 적절한 칼로리 공급을 위해 영양 상담이
                  도움이 됩니다.
                </p>
              </dd>
            </dl>
          </div>
        </div>
      ),
    },
    {
      value: 2,
      title: "아이가 잘 뛰어 놀 수 있을까요?",
      content: () => (
        <div className="collapse-content">
          <div className="ac_text ac1-2" style={{ marginBottom: 15 }}>
            <div className="top">
              <span>
                <img
                  src="/assets/img/icon/05-02.png"
                  style={{ width: 100, minWidth: 100 }}
                  alt=""
                />
              </span>
              <p style={{ color: "#000" }}>
                CDH는 폐 발달에 영향을 미치며, 특히 폐고혈압과 같은 심폐
                합병증을 동반할 수 있습니다. CDH 아기의 약 40-60%가 신생아기에
                폐고혈압을 경험하며 20-30% 아기들은 신생아 중환자실 퇴원
                이후에도 폐고혈압이 지속됩니다. 이는 폐 기능과 전반적인 건강에
                장기적인 영향을 미칠 수 있습니다.
              </p>
            </div>
          </div>
          <div className="ac_text ac5-2">
            <dl>
              <dt>01</dt>
              <dd>
                <h2>호흡 상태 관찰</h2>
                <p>
                  아기의 호흡이 빠르거나 청색증이 나타나는 경우 진료가
                  필요합니다. 폐동맥 고혈압이 있는 아기들은 호흡 곤란을 겪을
                  가능성이 더 크기 때문에 보호자가 아기의 호흡 상태를 주의 깊게
                  관찰하는 것이 중요합니다.
                </p>
              </dd>
            </dl>
            <dl>
              <dt>02</dt>
              <dd>
                <h2>산소 치료</h2>
                <p>
                  일부 CDH 아기들은 퇴원 후에도 산소 치료 또는 가정용 호흡기
                  치료가 필요합니다. 폐고혈압이 있는 아기의 경우, 산소 공급은
                  폐동맥 압력을 감소시켜 폐 기능을 향상시키는 데 도움이 될 수
                  있습니다. 가정 내 산소 치료를 지속하며, 아기의 산소 포화도를
                  주기적으로 확인하고, 아기의 폐 상태가 좋아지면 산소 치료를
                  줄이거나 중단하게 됩니다.
                </p>
              </dd>
            </dl>
            <dl>
              <dt>03</dt>
              <dd>
                <h2>폐고혈압 치료</h2>
                <p>
                  폐고혈압 또는 폐동맥 고혈압이 있는 경우 약물 치료가 시행될 수
                  있습니다. 퇴원 후 가정에서 처방되는 약물로는 폐혈관을
                  확장시키는 작용을 하는 Sildenafil, Bosentan, Treprostinil 등이
                  있습니다. 소아청소년과, 특히 소아심장과에서 정기적인
                  심장초음파를 통해 폐고혈압 상태를 모니터링하며 약물을 조절하게
                  됩니다.
                </p>
                <span>
                  <img src="/assets/img/ac5-1.png" alt="" />
                </span>
              </dd>
            </dl>
            <dl>
              <dt>04</dt>
              <dd>
                <h2>정기적인 폐기능 평가</h2>
                <p>
                  CDH 아기의 폐 기능이 정상적으로 발달하고 있는지 평가하기 위해
                  학동기 이전 폐기능 검사를 시행하게 됩니다. 폐동맥 고혈압이
                  완전히 해결되지 않으면 폐 기능과 심장 기능에 장기적인 영향을
                  미칠 수 있으므로 지속적인 관리가 필요합니다.
                </p>
              </dd>
            </dl>
          </div>
        </div>
      ),
    },
    {
      value: 3,
      title: "아이가 잘 먹지를 못해요. 좋은 방법이 없을까요?",
      content: () => (
        <div className="collapse-content">
          <div className="ac_text ac1-2" style={{ marginBottom: 10 }}>
            <div className="top" style={{ marginBottom: 10 }}>
              <span>
                <img
                  src="/assets/img/icon/05-03.png"
                  style={{ width: 100, minWidth: 100 }}
                  alt=""
                />
              </span>
              <dl style={{ paddingLeft: 0, marginTop: 0 }}>
                <dt>01</dt>
                <dd>
                  <h2>수유 곤란</h2>
                  <p>
                    CDH 아기들은 위식도역류를 비롯한 다양한 수유 문제가
                    발생합니다. 수유 문제는 위장관의 구조적 기능적 문제 뿐
                    아니라 뇌손상, 호흡 상태, 뇌손상, 발달 지연 등 다양한 원인이
                    관계됩니다. 폐가 충분히 발달하지 못하여 장기간 기관지 삽관과
                    인공호흡기 치료가 필요했던 경우 특히 잘 삼키지 못하는
                    아기들이 많습니다. 또한 일상 생활에서도 산소 치료가 필요할
                    정도로 만성폐질환이 있는 경우는 빠른 호흡 또는 많은 호흡
                    노력이 필요하므로 입으로 먹고 삼키는데 지장을 줄 수
                    있습니다. 일부 아기들은 코-위관 또는 입-위관을, 드물지만
                    위루관을 가지고 퇴원하는 경우도 있습니다. 수유 곤란이 장기간
                    지속된다면 구강 자극 치료 등 재활의학과 중재를 통해 도움을
                    받을 수 있습니다.
                  </p>
                </dd>
              </dl>
            </div>
          </div>
          <div className="ac_text ac4-6">
            <dl>
              <dt>02</dt>
              <dd>
                <h2>영양 공급 방법</h2>
                <p>
                  아기가 잘 먹지 못하는 경우에는 다양한 방법의 영양 지원이
                  필요합니다. 다만 일부 아기들은 충분한 영양 섭취에도 불구하고
                  성장이 지연되는 경우도 확인됩니다. 다음은 아기의 수유에 도움을
                  줄 수 있는 몇 가지 방법입니다.
                </p>
                <ul className="type3">
                  <li>
                    <span>•</span>성장 지연과 무관하게 가능한 모유 수유를
                    권장합니다.
                  </li>
                  <li>
                    <span>•</span>아기의 발달 상태에 따라 이유식 시작 시기가
                    지연될 수도 있습니다.
                  </li>
                  <li>
                    <span>•</span>한 번에 많은 양의 모유나 분유를 먹이는 것보다
                    적은 양을 자주 먹이는 것이 도움이 될 수 있습니다.
                  </li>
                  <li>
                    <span>•</span>잘 삼키지 못하는 아기를 위해 젖꼭지의 크기와
                    모양을 조절한 특수 젖꼭지를 시도해 보는 방법도 있습니다.
                  </li>
                  <li>
                    <span>•</span>너무 빠르게 수유하지 않도록 주의하고, 중간에
                    아기가 숨을 쉴 수 있도록 잠깐씩 멈추어 주는 것이 좋습니다.
                  </li>
                  <li>
                    <span>•</span>아기의 수유량이 절대적으로 부족하다면 전문
                    영양사의 조언을 받아 추가적인 영양 보충제나 영양강화 특수
                    분유나 유아식을 시도해 볼 수 있습니다.
                  </li>
                </ul>
              </dd>
            </dl>
            <dl>
              <dt>03</dt>
              <dd>
                <h2>위식도 역류</h2>
                <p>
                  위식도 역류는 위산이 위에서 식도를 통해 역류하는 상태를
                  말합니다. 이는 속쓰림, 소화불량, 구토 등의 증상을 유발할 수
                  있습니다. CDH아기들은 수술 후 위와 장이 재배치되면서 위식도
                  역류를 자주 경험하게 됩니다. CDH를 가진 아기들의 위식도 역류는
                  많게는 70%까지 보고될 정도로 흔합니다. 다행히 그 빈도는 1세
                  이후 감소합니다.
                </p>
                <br />
              </dd>
            </dl>
            <dl className="type4">
              <dd>
                <h4>
                  위식도 역류를 겪고 있는 아기에게 나타날 수 있는 증상은 다음과
                  같습니다.
                </h4>
                <ul className="type2">
                  <li>
                    <span>•</span>
                    <div className="text">
                      <h4>잦은 구토</h4>
                      <p>식사 후 위산이 역류하여 구토를 자주 할 수 있습니다.</p>
                    </div>
                  </li>
                  <li>
                    <span>•</span>
                    <div className="text">
                      <h4>소화불량</h4>
                      <p>
                        아기가 음식을 잘 소화하지 못하고 불편함을 호소할 수
                        있습니다.
                      </p>
                    </div>
                  </li>
                  <li>
                    <span>•</span>
                    <div className="text">
                      <h4>식사 중 또는 후에 불편함</h4>
                      <p>
                        아기가 먹는 도중 또는 식사 후에 울거나 불편해 보일 수
                        있습니다.
                      </p>
                    </div>
                  </li>
                  <li>
                    <span>•</span>
                    <div className="text">
                      <h4>체중 증가 저하</h4>
                      <p>
                        구토와 역류로 인해 아기가 제대로 음식을 흡수하지 못해
                        체중이 증가하지 않을 수 있습니다.
                      </p>
                    </div>
                  </li>
                  <li>
                    <span>•</span>
                    <div className="text">
                      <h4>수면 중 불편함</h4>
                      <p>
                        위산이 식도로 올라오면서 아기가 잘 때 불편해하거나
                        잠에서 깰 수 있습니다. 약물 치료로 조절되지 않는 심한
                        위식도역류는 Nissen fundoplication (위바닥 주름술) 같은
                        수술적 치료가 필요할 수 있습니다. 이 수술은 위의 상부를
                        식도 주위로 감싸 위산이 식도로 역류하는 것을 방지하는
                        수술입니다.
                      </p>
                    </div>
                  </li>
                  <li>
                    <span>•</span>
                    <div className="text">
                      <h4>흉통 또는 속쓰림</h4>
                      <p>
                        나이가 들면서 아기가 속이 쓰리거나 흉부 통증을 호소할 수
                        있습니다.
                      </p>
                    </div>
                  </li>
                </ul>
              </dd>
            </dl>
            <dl className="type4">
              <dd>
                <h4>
                  CDH로 인한 위식도 역류는 아기의 생활에 영향을 미칠 수 있지만,
                  여러 가지 방법을 통해 관리할 수 있습니다.
                </h4>
                <ul className="type2">
                  <li>
                    <span>•</span>
                    <div className="text">
                      <h4>수유 자세 조정</h4>
                      <p>
                        아기를 수유할 때, 가능한 한 아기의 머리를 높게 유지하여
                        위산이 역류하지 않도록 도와줄 수 있습니다.
                      </p>
                    </div>
                  </li>
                  <li>
                    <span>•</span>
                    <div className="text">
                      <h4>수유 간격 조절</h4>
                      <p>
                        자주 적은 양씩 먹이는 것이 도움이 될 수 있습니다. 한
                        번에 많은 양을 먹이면 역류가 더 잘 발생할 수 있기
                        때문입니다.
                      </p>
                    </div>
                  </li>
                  <li>
                    <span>•</span>
                    <div className="text">
                      <h4>특수 조제 분유</h4>
                      <p>
                        위식도 역류를 줄이기 위해 역류 방지 분유나 의사가
                        추천하는 특수 분유를 시도해 볼 수 있습니다.
                      </p>
                    </div>
                  </li>
                  <li>
                    <span>•</span>
                    <div className="text">
                      <h4>약물 치료</h4>
                      <p>
                        증상이 심한 경우, 의사는 위산을 억제하거나 역류를
                        줄여주는 약물을 처방할 수 있습니다. 이는 식도로 올라오는
                        위산을 줄여 식도의 자극을 줄이는 데 도움이 됩니다.
                      </p>
                    </div>
                  </li>
                  <li>
                    <span>•</span>
                    <div className="text">
                      <h4>수술적 치료</h4>
                      <p>
                        심한 위식도 역류가 약물로 조절되지 않을 경우, 위식도
                        조영술을 시행하여 역류의 원인과 정도를 파악하게 됩니다.
                        약물 치료로 조절되지 않는 심한 위식도역류는 Nissen
                        fundoplication (위바닥 주름술) 같은 수술적 치료가 필요할
                        수 있습니다. 이 수술은 위의 상부를 식도 주위로 감싸
                        위산이 식도로 역류하는 것을 방지하는 수술입니다.
                      </p>
                    </div>
                  </li>
                </ul>
              </dd>
            </dl>
            <h5>
              위식도 역류는 선천성 횡격막 탈장(CDH)을 가진 아기들에게 흔한
              문제이지만, 적절한 관리와 치료로 증상을 완화하고 아기의 전반적인
              건강을 향상시킬 수 있습니다. 아기의 역류 증상을 관찰하고, 필요한
              경우 의료진과 상의하여 최선의 치료 계획을 세우는 것이 중요합니다.
            </h5>
          </div>
        </div>
      ),
    },
    {
      value: 4,
      title: "아이의 가슴 모양과 자세가 이상합니다. 어떻게 해야 할까요?",
      content: () => (
        <div className="collapse-content">
          <div className="ac_text ac1-2" style={{ marginBottom: 15 }}>
            <div className="top">
              <span>
                <img
                  src="/assets/img/icon/05-04.png"
                  style={{ width: 100, minWidth: 100 }}
                  alt=""
                />
              </span>
              <p style={{ color: "#000" }}>
                CDH 아기들은 수술 후 정형외과적 문제가 생길 수 있습니다. 특히
                척추와 흉곽의 발달을 주기적으로 평가받는 것이 중요합니다.
              </p>
            </div>
          </div>
          <div className="ac_text ac5-4">
            <dl>
              <dt>01</dt>
              <dd>
                <h2>흉곽 변형</h2>
                <p>
                  <b>흉곽 변형</b>은 CDH 환자에서 가장 흔히 나타나는 정형외과적
                  문제 중 하나입니다. 태아기부터 횡격막에 결손으로 복부 장기가
                  흉곽으로 이동하면서 흉곽 구조에 영향을 미치게 됩니다. 또한
                  수술 후 폐 성장과 횡격막 비대칭이 흉곽 발달에 영향을 미칠 수
                  있습니다.
                </p>
                <ul className="type2">
                  <li>
                    <span>•</span>
                    <div className="text">
                      <h4>흉곽 비대칭</h4>
                      <p>
                        CDH로 인해 한쪽 흉부가 비대칭적으로 발달할 수 있습니다.
                        복부 장기가 흉강으로 들어가면 폐와 가슴의 발달이
                        제한되고, 이는 흉곽이 정상적으로 발달하지 못하게 합니다.
                      </p>
                    </div>
                  </li>
                  <li>
                    <span>•</span>
                    <div className="text">
                      <h4>흉곽 오목증(Pectus Excavatum)</h4>
                      <p>
                        일부 환자들은 흉골이 안으로 함몰되는 흉곽 오목증이
                        발생할 수 있습니다. 이 변형은 심장과 폐에 압박을 줄 수
                        있어 호흡 문제를 더 악화시킬 수 있습니다.
                      </p>
                      <div className="ac_text ac3-4" style={{ marginBottom: 0 }}>
                        <div className="img" style={{ maxWidth: 300 }}>
                          <img src="/assets/img/ac5-10.png" alt="" />
                        </div>
                        <h6 stlye={{ paddingRight: 30 }}>[흉곽 오목증]</h6>
                      </div>
                    </div>
                  </li>
                  <li>
                    <span>•</span>
                    <div className="text">
                      <h4>흉곽 융기증(Pectus Carinatum)</h4>
                      <p>
                        반대로 흉골이 밖으로 돌출되는 흉곽 융기증이 나타날 수도
                        있습니다. 이 변형은 심미적인 문제 외에도, 흉부 압박감을
                        유발할 수 있습니다.
                      </p>
                    </div>
                  </li>
                </ul>
              </dd>
            </dl>
            <dl>
              <dt>02</dt>
              <dd>
                <h2>척추측만증</h2>
                <p>
                  척추측만증은 척추가 비정상적으로 옆쪽으로 휘어지는 질환입니다.
                  흉곽과 척추는 서로 밀접하게 연결되어 있기 때문에, 흉곽 변형이
                  척추의 비정상적인 발달을 유도할 수 있습니다. CDH로 인해 한쪽
                  폐와 흉곽이 충분히 발달하지 않으면, 신체 균형이 맞지 않게 되고
                  척추측만증이 발생할 수 있습니다.
                </p>
                <p>
                  척추측만증이 심한 경우, 등이나 허리의 통증, 자세 문제, 그리고
                  심한 경우 호흡과 심장 기능에 영향을 미칠 수 있습니다.
                  일반적으로 평소에 아이가 바른 자세를 유지할 수 있도록 돕는
                  것도 중요합니다. 정형외과 전문의에게 정기적인 검진을 받아야
                  합니다. 필요한 경우 물리치료나 자세 교정 기구를 사용해 척추와
                  흉곽의 건강을 지킬 수 있습니다.
                </p>
                <div className="ac_text ac3-4" style={{ marginBottom: 0 }}>
                  <div className="img" style={{ width: 250 }}>
                    <img src="/assets/img/ac5-11.png" alt="" />
                  </div>
                  <h6 style={{ paddingRight: 30 }}>[척추 측만증의 X선 사진]</h6>
                </div>
              </dd>
            </dl>
            <dl>
              <dt>03</dt>
              <dd>
                <h2>근력 약화와 운동 능력 저하</h2>
                <p>
                  CDH 아이들은 원래 가지고 있던 호흡기나 심장 문제는 물론 긴
                  입원 기간과 제한된 신체 활동으로 인해 근력 발달이 늦어질 수
                  있습니다. 특히 흉부와 복부 근육이 약화될 수 있으며, 이는 자세
                  문제나 운동 발달에 영향을 줄 수 있습니다. 재활의학 전문의의
                  평가 후 물리치료가 도움이 될 수 있습니다.
                </p>
              </dd>
            </dl>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="acco">
      <MyCollapse data={content} />

      <div className="ac_text">
        <div className="info_text">
          <p>
            선천성 횡격막 탈장을 가진 아이 중 일부는 퇴원 후 성장, 발달,
            영양공급, 정형외과적 문제를 겪을 수 있어 정기적인 추적 관찰이
            필요합니다. 여러 소아 진료 전문가들은 아이의 건강을 위해 최선을 다
            할 것입니다.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutUs05;
